import { PoweredByArovy } from '@ui/icons';
import { SharedDataDictionaryTable } from './SharedDataDictionaryTable';
import { coreActions } from '@sonar-software/sonar-core';
import React, { useCallback, useMemo } from 'react';
import { useAction, useQueryParams } from '@hooks';
export const SharedDataDictionary = ({ data, loading, viewKey }) => {
    const requestView = useAction(coreActions.requestGetCoreDataDictionaryViewsSharedKey);
    const initialParams = useMemo(() => ({
        count: 10,
        filterByName: undefined,
        sharedKey: viewKey
    }), [viewKey]);
    const handleUpdate = useCallback((_, __, combined) => {
        requestView(combined);
    }, [requestView]);
    const { updateParams } = useQueryParams({
        defaultParams: initialParams,
        onUpdate: handleUpdate
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(SharedDataDictionaryTable, { loading: loading, resource: data, updateQuery: updateParams }),
        React.createElement(PoweredByArovy, { className: 'shared-view-footer-logo' })));
};
